import React from 'react';
export function AgitationSection() {
  const consequences = ["Players who plateau and don't progress", 'Sessions that feel chaotic instead of purposeful', 'Coaches who burn out and quit', 'Kids who lose interest and drop the sport'];
  return <section className="bg-forest py-20 px-4 relative overflow-hidden" data-id="element-19">
      {/* Subtle texture/pattern overlay could go here */}
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-20">
        <h2 className="font-display text-4xl md:text-5xl text-white text-center mb-8 uppercase" data-id="element-21">
          Why Most Youth Coaches Stay Stuck in{' '}
          <span className="text-amber" data-id="element-22">Planning Purgatory</span>
        </h2>

        <p className="text-lg text-gray-300 mb-8 leading-relaxed text-center" data-id="element-23">
          Most coaches have the passion, but no system. They've been told to
          "just Google drills" or "watch coaching videos" — but that approach
          leaves them with scattered ideas and no coherent plan for player
          development.
        </p>

        <div className="bg-ink/50 rounded-xl p-8 mb-10 border border-white/5" data-id="element-24">
          <p className="text-white font-bold mb-6 text-center uppercase tracking-wider text-sm" data-id="element-25">
            The Cost of Having No System:
          </p>
          <ul className="grid md:grid-cols-2 gap-4" data-id="element-26">
            {consequences.map((item, index) => <li key={index} className="flex items-center gap-3 bg-ink/80 p-4 rounded-lg border border-white/5" data-id="element-27">
                <div className="w-2 h-2 rounded-full bg-amber shrink-0" data-id="element-28"></div>
                <span className="text-gray-200" data-id="element-29">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-30">
          <p className="text-2xl font-display tracking-wide text-white bg-ink inline-block px-8 py-4 rounded-lg border border-white/10 shadow-xl" data-id="element-31">
            "The problem isn't your commitment. <br className="md:hidden" data-id="element-32" />
            <span className="text-brightGreen" data-id="element-33">
              It's that you've never had a system built for you.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}